import * as React from 'react';
import './footer.scss';
import { getLanguageDefault, isBrowser, LanguageList, URL_PATHNAME, FooterLinkV2 } from '../../utils/Utils';
import { useState, useEffect } from 'react';
import { FooterManagerAPI } from '../../services';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const Footer = props => {
  const { t } = props;
  const [params, setParams] = useState(null);
  const url = isBrowser() ? window.location.pathname : '';
  const navigate = useNavigate();
  const languageCode = isBrowser() ? getLanguageDefault()?.code || 'DE' : 'DE';

  const navigateToDonation = () => {
    navigate(URL_PATHNAME.DONOR_PORTAL + '?lang=' + t('language'));
  };

  const getFooterPatrams = async () => {
    try {
      // const { data: footers } = await FooterManagerAPI.getFooters();
      // setParams(JSON.parse(footers.records.filter(f => f.is_primary !== true)[0].parameters));
    } catch (error) {
      setParams({});
    }
  };

  useEffect(() => {
    getFooterPatrams();
  }, []);

  const clickOnContact = () => {
    if (window && window['Beacon']) {
      window['Beacon']('open');
      window['Beacon']('navigate', '/ask/message');
    }
  };

  const openCookiesPopup = () => {
    if (window && window['Cookiebot']) {
      window['Cookiebot'].renew();
    }
  };

  return (
    <>
      {url !== URL_PATHNAME.DONOR_PORTAL && (
        <div className="footer">
          <div className="footer-bg">
            <div className="footer-bg-container">
              <div className="row">
                <div className="col-md-8">
                  <div className="footer-text">
                    <p>{t('footer_description')}</p>
                  </div>
                </div>
                <div className="col-md-4" style={{ display: 'flex' }}>
                  <div className="btn-email-address">
                    <Button
                      label={t('check_another_email')}
                      className="p-button-raised p-button-text"
                      icon="pi pi-chevron-right"
                      iconPos="right"
                      onClick={() => navigateToDonation()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <footer id="main-footer" className="bg_prime aw_footer">
        <div className="aw_container aw_footer__sub">
          <div className="aw_row">
            <div className="col_12 pt32 pb32">
              <ul>
                <li>
                  <a
                    id="963188cc-08d8-4909-a6e1-1fc3ef1e578f"
                    className="wi_footer_item aw_rich_text"
                    rel="noreferrer"
                    href={FooterLinkV2.Imprint[languageCode || 'DE']}
                    target="_blank"
                  >
                    {t('imprint')}
                  </a>
                </li>
                <li>
                  <a
                    id="53155ac9-7ac0-43ad-b205-7c97c3273c45"
                    className="wi_footer_item aw_rich_text"
                    rel="noreferrer"
                    href={FooterLinkV2.AGB[languageCode || 'DE']}
                    target="_blank"
                  >
                    {t('agb')}
                  </a>
                </li>
                <li>
                  <a
                    id="975e7241-979c-4542-b100-94226b1d6b25"
                    className="wi_footer_item aw_rich_text"
                    rel="noreferrer"
                    href={FooterLinkV2.Privacy[languageCode || 'DE']}
                    target="_blank"
                  >
                    {t('privacy')}
                  </a>
                </li>
                <li>
                  <a id="b108b46f-dbfb-4c4c-b92f-dd8f30f9e51f" className="wi_footer_item aw_rich_text" rel="noreferrer" onClick={clickOnContact}>
                    {t('contact')}
                  </a>
                </li>
                <li>
                  <a id="b108b46f-dbfb-4c4c-b92f-dd8f30f9e512" className="wi_footer_item aw_rich_text" rel="noreferrer" onClick={openCookiesPopup}>
                    {t('cookies')}
                  </a>
                </li>
              </ul>
              <div>
                <i className="aw_icon mr4">&#xe904;</i>
                <i className="aw_icon mr4">&#xe931;</i>
                <i className="aw_icon mr4">&#xe92e;</i>
                {/* <i className="aw_icon mr4">&#xe930;</i> */}
                <i className="aw_icon mr4">&#xe934;</i>
                <i className="aw_icon">&#xe935;</i>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default withTranslation('language')(Footer);
